import { FormSelectYesNo } from '../../formelements'



const AuthRecursosDigitals = ({auth, handleChange, error }) => 
{
    return (<>

        <div className="row">
            <div className="col col-12 ">

                <FormSelectYesNo
                    id="authRecursosDigitals"
                    name="authRecursosDigitals"
                    col="col-4"
                    label="Autoritzo"
                    obligatori={true}
                    value={auth}
                    handleChange={(e) => handleChange(e.target.value)}
                    error={error}
                />
            </div>
        </div>

        <br/>

        <p>
            La gestió d'aquests identificadors i la responsabilitat de l’ús que se'n faci en l'àmbit escolar correspon al
            centre educatiu. Aquest no es fa responsable de l’ús indegut del recurs i dels seus continguts per part dels
            usuaris. L'usuari serà únic responsable de les infraccions en què pugui incórrer o dels perjudicis que pugui
            causar per un us inadequat dels seus serveis o dels seus continguts.
        </p>

    </>)
}


export const AuthRecursosDigitalsMajors18 = ({auth, handleChange, error }) => 
{
    return (<>
        <div className="row">
            <div className="col col-12 ">
                <p>
                    Que estic assabentat que utilitzaré, per al treball acadèmic, els serveis telemàtics i/o apliacions de dispositius
                    mòbils que requereixen usuari i contrasenya que s'especifiquen a continuació:

                    <ul>
                        <li>G Suite educatiu / entorn Google  (Correu Drive, Calendar, Classroom, etc.)</li>
                        <li>Llibres digitals (Plataforma Weeras, Blink Learning, altres) </li>
                        <li>Moodle</li>
                        <li>Thatquiz / Kahoot / Altres eines TIC que es puguin incorporar al llarg del curs</li>
                    </ul>
                </p>
            </div>
        </div>

        <AuthRecursosDigitals auth={auth} handleChange={handleChange} error={error} />

    </>)
}

export const AuthRecursosDigitalsMenors18 = ({auth, handleChange, error }) => 
{
    return (<>
        <div className="row">
            <div className="col col-12 ">
                <p>
                    Que el meu fill/a utilitzi, per al treball acadèmic, els serveis telemàtics i/o apliacions de dispositius
                    mòbils que requereixen usuari i contrasenya que s'especifiquen a continuació:

                    <ul>
                        <li>G Suite educatiu / entorn Google  (Correu Drive, Calendar, Classroom, etc.)</li>
                        <li>Llibres digitals (Plataforma Weeras, Blink Learning, altres) </li>
                        <li>Moodle</li>
                        <li>Thatquiz / Kahoot / Altres eines TIC que es puguin incorporar al llarg del curs</li>
                    </ul>
                </p>
            </div>
        </div>


        <AuthRecursosDigitals auth={auth} handleChange={handleChange} error={error} />

    </>)
}